import { render } from "./RepairTable.vue?vue&type=template&id=33379b1c&scoped=true"
import script from "./RepairTable.vue?vue&type=script&lang=js"
export * from "./RepairTable.vue?vue&type=script&lang=js"

import "./RepairTable.vue?vue&type=style&index=0&id=33379b1c&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33379b1c"]])

export default __exports__